import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BetslipOnboardingMessageService } from './betslip-onboarding-message.service';
import { BetslipOnboardingComponent } from './betslip-onboarding.component';

@NgModule({
    imports: [CommonModule],
    providers: [BetslipOnboardingMessageService],
    declarations: [BetslipOnboardingComponent],
    exports: [BetslipOnboardingComponent],
})
export default class OnboardingModule {}
